export class LoyaltySession {
    constructor(session) {
        this.cartData = session.cartData;
        this.disableUnit = session.disableUnit;
        this.expiresAt = session.expiresAt;
        this.guestData = session.guestData;
        this.guestEmail = session.guestEmail;
        this.hideCalendar = session.hideCalendar;
        this.hidePrice = session.hidePrice;
        this.hidePromoCodes = session.hidePromoCodes;
        this.hideReservation = session.hideReservation;
        this.id = session.id;
        this.maxCartItems = session.maxCartItems;
        this.sessionType = session.sessionType;
        this.urlParams = session.urlParams;
    }
    static of(session) {
        return new LoyaltySession(session);
    }
    isCartAbandonmentSession() {
        return this.sessionType === "CART_ABANDONMENT_SESSION";
    }
    hasCartAbandonmentOrigin() {
        return this.urlParams.origin && this.urlParams.origin === "CART_ABANDONMENT_SESSION";
    }
}
